import { redirect } from "@client/actions";
import { globals } from "@client/globals";
import { type AppState } from "@client/types";
import { type ActionDispatch } from "@client/types/redux";
import { type Dispatch } from "react";

export enum Actions {
  SetSearchBarVisible = "HEADER_SEARCH_BAR_SET_VISIBLE",
  SetSticky = "HEADER_SET_STICKY",

  ToggleMenuOpen = "HEADER_MENU_TOGGLE_OPEN"
}

export const search = (text: string) => (dispatch: Dispatch<any>, getState: () => AppState) => {
  dispatch(
    redirect({
      redirectTo: {
        newTab: false,
        type: "tab",
        qs: ["search"],
        pageId: globals.siteInfo.searchPageId
      },
      qs: {
        search: text
      }
    })
  );
};

export const closeMenu = () => (dispatch: ActionDispatch<any>, getState: () => AppState) => {
  const state = getState();
  const {
    widgets: { header }
  } = state;

  if (header.isMenuOpen) {
    dispatch(toggleMenuOpen());
  }
};

export interface ToggleMenuOpenActionData {
  isOpen: boolean;
}
export const toggleMenuOpen = () => (dispatch: ActionDispatch<any>, getState: () => AppState) => {
  const state = getState();
  const {
    widgets: { header }
  } = state;

  const isOpen = !header.isMenuOpen;
  dispatch({
    type: Actions.ToggleMenuOpen,
    data: <ToggleMenuOpenActionData>{
      isOpen: isOpen
    }
  });
};

export interface SetSearchBarVisibleActionData {
  isVisible: boolean;
}
export const setSearchBarVisible = (isVisible: boolean) => ({
  type: Actions.SetSearchBarVisible,
  data: <SetSearchBarVisibleActionData>{
    isVisible
  }
});

export interface SetStickyActionData {
  isSticky: boolean;
}
export const setSticky = (isSticky: boolean) => ({ type: Actions.SetSticky, data: { isSticky } });

export const toggleSearchBar = () => (dispatch: Dispatch<any>, getState: () => AppState) => {
  const {
    widgets: { header }
  } = getState();
  const isVisible = !header.isSearchBarVisible;

  dispatch(setSearchBarVisible(isVisible));
};
